import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import withData from '../utils/withData'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import ContentBlocks from '../components/ContentBlocks'
import Window from '../components/Window'
import Loader from '../components/Loader'
import ScrollTo from '../components/ScrollTo'

import Instagram from '../components/Instagram'
import Twitter from '../components/Twitter'

import Asset from '../models/Asset'
import Entry from '../models/Entry'

import * as Break from '../components/Breakpoints'

let dataUrl
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    dataUrl = '//thefenway.archivestud.io'
} else {
    // production code
    dataUrl = '//thefenway.com'
}

// Data to preload before site initialises
const socialFeeds = [
  {
    name:'instagram',
    src:dataUrl + '/json/instagram.json'
  },
  {
    name:'twitter',
    src:dataUrl + '/json/twitter.json'
  }
]

class About extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {



	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log('entry',entry);
		//console.log(this.props);
		let intro;
		if(entry.image){

			intro = (
				<div className="Template-intro">
				<Item modifiers={['intro']}>

					<div className="Item-head">
						<div className="Item-title">
							<Content modifier={'yellow'}>
								<h1>{entry.title}</h1>
							</Content>
						</div>
						<div className="Item-subTitle">
							<Content>
								<h4>{entry.locationType}</h4>
							</Content>
						</div>
					</div>
					<div className="Item-media">
						{/*<Media id={entry.image[0]} />*/}
					</div>


				</Item>
				</div>
			)


		}else{

			intro = null;

		}

		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className="Template  Template--default  Template--about">

					{/* Template-head */}
					<div className="Template-head Template-head--about">

					<Window className="Template-intro">

						<Content modifier={'heading'} html={entry.summary}/>

					</Window>

					</div>
					{/* / Template-head */}

					{/* Template-body */}
					<div className="Template-body">

					<div className="Template-sections">

						{/* Template-section */}
							<div className="Template-section  Template-section--full Template-section--narrow  Template-section--mobileFlush  Template-section--first">
								<div className="Template-content">
									<Media id={entry.image[0]} ratio={1.5} fluid={false}/>
								</div>
							</div>
							{/* / Template-section */}

					{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--container Template-section--mobileFlush">
								<div className="Template-heading">
									<Content html="<h1>Speak up!</h1><p>Tell us who you are and get free stuff</p>" />
								</div>
								<div className="Template-content">
									<Newsletter />
								</div>
							</div>
							{/* / Template-section */}
					</div>



						<ContentBlocks blocks={entry.contentBlocks} modifier={'about'} />

					<div className="Template-sections">

							{/* Template-section */}
							<div className="Template-section Template-section--narrow Template-section--last">
								<div className="Template-heading">
									<Content html="<h1>Be Social</p>" />
								</div>
							</div>
							{/* / Template-section */}
					</div>

					</div>
					{/* / Template-body */}

					<Loader manifest={socialFeeds}>
			        	<div>
			        		<div className="Template-instagram">
			        		<Break.Default>
			        			<Instagram limit={12} items={this.props.data.instagram} />
			        		</Break.Default>
			        		<Break.Mobile>
			        			<Instagram limit={4} items={this.props.data.instagram} />
			        		</Break.Mobile>
			        		</div>
							<div className="Template-body">
			        		<Twitter items={this.props.data.twitter} />
			        		</div>
			        	</div>
			      	</Loader>


			</div>
			</FadeIn>
		);

	}
}

export default withData(About);



// WEBPACK FOOTER //
// ./src/js/templates/About.js